import template from './enrollmentAddOnModal.html';


class EnrollmentAddOnModalController {
    /* @ngInject */
    constructor($uibModal, dataContext, constants, $log, alertService) {
        this.$modal = $uibModal;
        this.$log = $log;
        this.dataContext = dataContext;
        this.constants = constants;
        this.data = this.config.data;
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
        this.alertService = alertService;
    }

    close() {
        this.$dismiss();
    }

    next() {
        this.close();
        const modalInstance = this.$modal.open({
            template: '<fp-terms-add-on-modal config="config"></fp-terms-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        safetyButtonAddOn: this.data.safetyButtonAddOn,
                        oldQuantity: this.data.oldQuantity,
                        newQuantity: this.data.newQuantity
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }
    
}

export default {
    template: template,
    bindings: {
        config: '<',
        safetyButtonAddOn: '<',
        oldQuantity: '<',
        newQuantity: '<'
    },
    controller: EnrollmentAddOnModalController
};